import React from "react";
import ConfirmEmailChange from "../components/account/ConfirmEmailChange/ConfirmEmailChange";

const ConfirmEmailChangePage = () => {
  return <ConfirmEmailChange />;
};

export default ConfirmEmailChangePage;
